<template>
  <v-app id="eyehunter" >
    <v-navigation-drawer
      width="220"
      clipped
      fixed
      v-model="drawer"
      app dark
    >
      <Menu></Menu>
    </v-navigation-drawer>

    <v-toolbar dark app fixed clipped-left dense color="primary">
      <v-toolbar-side-icon @click.stop="drawer = !drawer">
        <v-icon>fas fa-bars</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="100" class="mr-4" v-if="usuario">
        <v-toolbar-title slot="activator">
          <v-avatar
            size="20px"
            slot="activator"
          >
            <v-icon small left>fas fa-user-circle</v-icon>
          </v-avatar>
          <small>&nbsp;{{ usuario.username }}</small>
        </v-toolbar-title>
        <v-list>
          <v-list-tile @click="$router.push('/perfil')">
            <v-list-tile-title>
              <v-icon color="blue lighten-1" small>fas fa-wrench</v-icon>
              &nbsp;Configuracion</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="">
            <v-list-tile-title>
              <v-icon color="yellow darken-4" small>fas fa-sign-out-alt</v-icon>
              &nbsp;Salir</v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-menu>
    </v-toolbar>

    <v-content>
      <v-container fluid >
        <router-view v-on:show-message="showMessage($event)"></router-view>
      </v-container>
    </v-content>

    <v-snackbar :timeout="3000" :color="tipoAlerta" v-model="alerta">
      <v-icon dark>{{iconos[tipoAlerta]}}</v-icon>
      {{ textoMensaje }}
    </v-snackbar>
  </v-app>
</template>

<script>
console.log(process.env)
import login from './services/login'
import Menu from './components/Menu'
import "../node_modules/ag-grid/dist/styles/ag-grid.css";
import "../node_modules/ag-grid/dist/styles/ag-theme-material.css";
import errorService from './services/errorService'

  export default {
    name: 'EyehunterAdmin',
    components: {
      Menu
    },
    data: () => ({
      drawer: true,
      title: 'Eyehunter',
      alerta: false,
      textoMensaje: '',
      usuario: null,
      tipoAlerta: 'info',
      iconos: {
        success: 'far fa-check-circle',
        error: 'far fa-exclamation-circle',
        info: 'fas fa-info-circle',
      }
    }),
    methods: {
      showMessage: function(msg){
        this.textoMensaje = msg.msg || msg
        this.tipoAlerta = msg.tipo || 'info'
        this.alerta = true
      }
    },
    props: {
      source: String
    },
    beforeMount: async function () {
      let logged = await login.checarSesion()
      if (!logged.ok) {
        this.$router.replace({ path: '/login' })
      }
      this.usuario = await this.$getItem('user')
      this.showMessage('Bienvenido!')
    },

  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue